import { takeLatest, put, select } from 'redux-saga/effects';

import { loggedUserIdSelector } from '../../context/selectors';
import * as fetchMainConsent from '../../profiles/get-main-consent';
import { selectMainConsent } from '../../profiles/selectors';
import { appointmentConsentsModalActions } from '../appointment-consent-modal';

function* handleShowMainConsent() {
  const mainConsentEntity = yield select(selectMainConsent);
  const userId = yield select(loggedUserIdSelector);
  if (mainConsentEntity && mainConsentEntity.length > 0) {
    const {
      organization: { name: organizationName },
    } = mainConsentEntity[0];
    yield put(
      appointmentConsentsModalActions.open({
        consent: mainConsentEntity[0],
        organizationName,
        allConsents: mainConsentEntity,
        isMainConsentView: true,
        patientUserInfoId: userId,
      }),
    );
  }
}

export default function* handleAcceptedConsentSaga() {
  yield takeLatest(fetchMainConsent.actions.succeed, handleShowMainConsent);
}



// WEBPACK FOOTER //
// ./src/redux/healthboard/sagas/accepted-consent.js